import { AgGridReact } from "ag-grid-react";
import { useSelector } from "react-redux";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Popconfirm,
  Row,
  Select,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";

export const GroupGrid = ({
  row,
  refetch,
  setRefetch,
  handleNotification,
}) => {
  const { makeRequest } = useStoreUpdaterWithAPI();
  console.log(refetch);

  console.log(row);



  const columnDefs = [
    {
      headerName: "Serial No.",
      field: "serialNo",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex:1
    },
    {
      headerName: "Group ID",
      field: "groupID",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex:1
    },
    {
      headerName: "Department",
      field: "department",
      headerClass: "grid-table-header",
      cellStyle: { borderRightColor: " #e2e2e2" },
      flex:1
    },
    {
      headerName: "Delete",
      headerClass: "grid-table-header",
      flex:1,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            {/* <Button
              onClick={() => {
                console.log(params.data);
                modalOpen(params.data);
                // params.data.actions.update(params.data);
              }}
            >
              <EditOutlined />
            </Button> */}

            <Popconfirm
              title="Delete  Converter Configuration"
              description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => {
                console.log(params.data);
                deleteConverter(params.data);
                // params.data.actions.confirmDelete(params.data.groupID);
              }}
              trigger="click"
            >
              <Button className="text-red-500 border-red-500">
                <DeleteOutlined className="text-red-500 "/>
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
  };
  
  function getGroupID(group) {
    const { groupID } = group;
    return { groupID };
  }

  const deleteConverter = (formValues) => {
    console.log(formValues);

    const body = getGroupID(formValues);

    const url = `${APIConstants.ELECTRICAL_GROUP_DELETE}`;

    console.log(url);
    console.log(body);

    makeRequest({
      type: APIConstants.DELETE,
      url: url,
      body: body,
    }).then((res) => {
      console.log(res);
      setRefetch(!refetch);
      handleNotification(res.message, "error");
    });
  };

  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

  const rowData = addSerialNumbers(row);
  function addSerialNumbers(objectsArray) {
    return objectsArray.map((obj, index) => ({
        ...obj,
        serialNo: index + 1
    }));
  }
  console.log(rowData);


  return ( 
    <div
      className="ag-theme-alpine "
      style={{ height: '58vh', overflowX: "auto",overflowY:'hidden' }}
    >
      <AgGridReact
        columnDefs={columnDefs} 
        rowData={rowData}
        pagination={"Yes"}
        className={`  ${
          isdarkMode
            ? "custom-table-dark-group custom-table-dark-parameter"
            : "whitemode"
        } `}
        // domLayout="autoHeight"
         domLayout="normal"
         
        />
    </div>
  );
};
